import { forwardRef } from 'preact/compat';
import { HandleTabIndex } from '@/features/elements';
import { makeClassName } from '@/utils';
import { useFormProps, useConfigStore } from '../stores/ConfigStore';
import SvgIcon from './SvgIcon';

export default forwardRef(function ActionButton(
	{ children, type, id, onClick = () => {}, loading, style = {} },
	ref
) {
	const { formKey } = useFormProps();
	const { properties } = useConfigStore();

	return (
		<HandleTabIndex
			component="button"
			ref={ref}
			className={`btn ${
				type === 'submit'
					? 'btn-primary btn-submit pull-right'
					: type === 'next'
					? 'btn-next pull-right'
					: 'btn-previous'
			} ${loading ? 'is-submitting' : ''}`}
			id={type !== 'submit' ? `btn_${type}_${id}` : `surveySubmitBtn-${formKey}`}
			type="button"
			onClick={onClick}
			style={style}
			data-testid={type}
			disabled={loading}
		>
			{loading && (
				<div className={makeClassName('btn-overlay')}>
					<SvgIcon
						icon="refresh"
						className="is-refresh-icon"
						alt="refresh icon"
					/>
				</div>
			)}
			<div className={makeClassName('btn-content')}>{children}</div>
		</HandleTabIndex>
	);
});
